export default __webpack_public_path__ + "static/media/Group698.64a031dd.svg";